module.exports = __webpack_public_path__ + "img/medellin-logo-light.c6bc29e1.svg";